import React from 'react';

const RESTGIS = () => (
  <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
    <h2>REST Assured: Real-Time GIS</h2>

    <p>
      On many infrastructure projects, connecting systems is a recurring challenge. Field data gets collected, but it often sits in silos or takes days to reach the people who need it.
    </p>

    <p>
      This is a workbench built in FME to automate GIS data updates, improve visibility and improve workforce productivity.
    </p>
    <p>The setup works like this:</p>
    <ul>
      <li>HTTPCallers connect to the 12d Synergy REST API and pull raw files (survey, utilities, design).</li>
      <li>A Python script filters for changes from the past week.</li>
      <li>Updated files are uploaded to ArcGIS Online using the ArcGISOnlineConnector.</li>
      <li>The whole workflow is scheduled to run weekly in FME Flow (cloud).</li>
    </ul>

    <p>
      The data is automatically cleaned and published, so stakeholders always have access to the latest information without manual handling.
    </p>

    <p>
      Outcome: less manual work, up-to-date maps every week, and a scalable model for smarter data delivery.
    </p>
  </main>
);

export default RESTGIS;
